import verificaCodiceFiscale from "../codice-fiscale.js";

export default function(){
    this.main.codiceFiscale = function codiceFiscale(cb){
        this.rule.required = this.isRequiredIf();
        if(this.validates()){
            this.required();
            if(this.rule.required && this.value === undefined){
                return cb();
            }
            if(this.value){
                if(typeof this.value !== "string"){
                    this.raise("Il campo %s deve essere una stringa");
                } else if(!verificaCodiceFiscale(this.value)){
                    this.raise("Il campo %s non è valido");
                }
            }
        }
        cb();
    };
}
